import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { from, of } from 'rxjs';
import { getFullPath } from '../lib/get-full-path';
import { PICFLOW_ANALYTICS } from '../picflow-analytics';
import { AuthRedirectService } from '../services/auth-redirect.service';
import { BrowserService } from '../services/browser.service';

export const loggedInRedirectGuard: CanActivateFn = route => {
  const browserService = inject(BrowserService);
  const authRedirectService = inject(AuthRedirectService);
  const analytics = inject(PICFLOW_ANALYTICS);

  const loggedIn = browserService.getCookies()?.['picflow-loggedin'] === 'true';
  if (!loggedIn) return of(true);

  const path = getFullPath(route);

  if (path[0] === 'auth' && ['login', 'signup'].includes(path[1])) {
    if (route.queryParams.__clerk_ticket) return of(true);
    if (route.queryParams.redirect_url) return of(true);
    return from(authRedirectService.redirectAfterLogin(route));
  }

  if (!analytics.lastUrl && path.length === 0) {
    return from(authRedirectService.redirectAfterLogin(route));
  }

  return of(true);
};
